import React, { useImperativeHandle, useRef, forwardRef } from 'react';
import customStyles from "../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Space, Modal, Row, Col, Image } from "antd";
import { Button } from "@mui/material";
import logoImg from "../../../../assets/images/logo.png";
import moment from 'moment';
import { currencyFormat } from "../../../../helpers/utilities";
import CloseIcon from "../../../../assets/images/icon_menus/Close Button.svg";
import Artboard from "../../../../assets/images/currency/Artboard.png";
import { MediumFont, NormalFont } from "../font";
import jsPDF from 'jspdf';

const PaymentReceipt = forwardRef((props, ref) => {
    const { open, details, handleClose, title } = props;
    const classes = customStyles();
    const pdfExportComponent = useRef(null);


    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    useImperativeHandle(ref, () => ({
        handleDownload() {
            handleDownload();
        },
    }));

    const handleDownload = (type = 'download') => {
        const content = pdfExportComponent.current;
        const doc = new jsPDF('pt', 'px', 'a4');
        doc.addFileToVFS('Roboto-Regular.ttf', NormalFont);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.addFileToVFS('Roboto-Medium.ttf', MediumFont);
        doc.addFont('Roboto-Medium.ttf', 'RobotoMedium', 'normal');
        doc.setFont("Roboto");
        doc.setFont("RobotoMedium");

        doc.html(content, {
            //fontFaces: fonts,
            callback: function (doc) {
                doc.addImage(Artboard, 'PNG', 100, doc.internal.pageSize.height - 275, 400, 54, '', '', 45);
                if (type === 'print') {
                    doc.autoPrint();
                    window.open(doc.output('bloburl'));
                } else {
                    doc.save(`${title}`);
                }
            },
            autoPaging: 'text',
            margin: 10,
            html2canvas: { scale: 0.434 } // change the scale to whatever number you need
        });
    };

    const calculateTaxTotal = () => {
        const planAmount = details?.subscriptionOrder?.plan?.planAmount;
        const percentage = 18;
        let cgstAmount = ''; let sgstAmount = ''; let igstAmount = '';
        let cgst = 0; let sgst = 0; let igst = 0;
        let gAmount = parseFloat(planAmount - (planAmount * (100 / (100 + percentage)))).toFixed(2);
        if (planAmount) {
            if (details?.business?.stateId !== 95 || details?.business?.taxType?.taxCode === 'SPEZ') {
                igst = percentage;
                igstAmount = parseFloat(planAmount - (planAmount * (100 / (100 + (percentage))))).toFixed(2);
            } else {
                cgst = (percentage / 2);
                sgst = (percentage / 2);
                cgstAmount = parseFloat((planAmount - (planAmount * (100 / (100 + percentage)))) / 2).toFixed(2);
                sgstAmount = parseFloat((planAmount - (planAmount * (100 / (100 + percentage)))) / 2).toFixed(2);
            }
        }

        return {
            cgst: cgst,
            sgst: sgst,
            igst: igst,
            cgstAmount: cgstAmount,
            sgstAmount: sgstAmount,
            igstAmount: igstAmount,
            amount: planAmount - gAmount
        }
    }

    return (
        <Modal title="" open={open} footer={null}
            onCancel={() => handleClose()}
            width={1030}
            closable={false}
            ref={ref}
            className={clsx(classes.invoiceDesign, classes.removeUnderline)}>
            <Row gutter={75} className={classes.invoiceHeader}>
                <Col span={5}>
                </Col>
                <Col span={5}>
                </Col>
                <Col span={14} className={clsx(classes.textAlignRight, classes.fontSize0)}>
                    <Space direction="horizontal" align="center" size={[20, 20]}>
                        <Button
                            key="confirm"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownload('print')}
                            className={clsx(classes.AddMoreBtn)}
                        >Print</Button>
                        <Button
                            key="save"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownload()}
                            className={clsx(classes.modalBtn)}
                        >Download</Button>
                        <Image onClick={() => handleClose()} alt={'Download'} src={CloseIcon} preview={false} className={classes.cursor} />
                    </Space>
                </Col>
            </Row>
            <div ref={pdfExportComponent} style={{ fontFamily: "Roboto" }} className={clsx(classes.divToPrint, classes.paymentReceipt, classes.margin30t)} id={"divToPrint"}>
                {/* <div className={clsx(classes.divToPrintCommand, "divToPrintCommand")} >
                    <Image
                        src={Artboard}
                        preview={false}
                        className={classes.currencyIcon}
                    />
                </div> */}
                <div className={classes.downloaddetails}>
                    <div className={classes.receiptHeader}>
                        <img src={logoImg} alt={'logo'} style={{ width: 150, height: "auto" }} />
                        <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={clsx(classes.receiptHeaderCenter, classes.bold)}>Payment Receipt</div>
                        <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={classes.receiptHeaderRight}><span>Order No. </span> {details?.subscriptionOrder?.subscriptionOrderId}</div>

                    </div>
                    <Row className={classes.yellowBorderTop}>
                        <Col span={12} className={clsx(classes.borderRight, classes.bill, classes.billtoppadding)}>
                            <h6>Bill From</h6>
                            <p className={classes.margin10PaymentTop}>Younote Private Limited</p>
                            <p>V02, Cactus Corporate Coworking, 4th Floor block A, </p>
                            <p>Tecci Park, OMR, Sholinganallur,</p>
                            <p>Chennai - 600119, Tamil Nadu, India</p>
                        </Col>
                        <Col span={12} className={clsx(classes.bill, classes.billtoppadding)}>
                            <h6>Bill To</h6>
                            <p className={classes.margin10PaymentTop}>{details?.business?.name || '---'}</p>
                            <p>{address(details?.business)}</p>
                            <p>{address1(details?.business)}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} className={clsx(classes.borderRight, classes.bill, classes.billbottompadding,)}>
                            <Row>
                                <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <h6>GSTIN</h6>
                                        </Col>
                                        <Col span={18}>
                                            <p>33AABCY3180B1ZR</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <h6>Ph No.</h6>
                                        </Col>
                                        <Col span={18}>
                                            <p>{9444146705}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={12} className={clsx(classes.bill, classes.billbottompadding)}>
                            <Row>
                                <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <h6>GSTIN</h6>
                                        </Col>
                                        <Col span={18}>
                                            <p>{details?.business?.gstNumber || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <h6>Ph No.</h6>
                                        </Col>
                                        <Col span={18}>
                                            <p>{details?.business?.mobile || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className={clsx(classes.receiptSecondSection, classes.bill, classes.yellowBorderTop)}>
                        <Col span={24}>
                            {/* <p className={clsx(classes.receiptSecondSectionTitle, classes.bold)}>Payment Details</p> */}
                            <Row>
                                <Col span={6}><h6>Order Date</h6></Col>
                                <Col span={6}><h6>Payment Amount</h6></Col>
                                <Col span={6}><h6 style={{ paddingLeft: 15 }}>Payment Received</h6></Col>
                                <Col span={6}><h6 className={classes.textAlignRight}>Balance</h6></Col>
                            </Row>
                            <Row className={classes.margin15t}>
                                <Col span={6}><p>{details?.subscriptionOrder?.subscriptionOrderDate ? moment(details?.subscriptionOrder?.subscriptionOrderDate).format('DD MMM YYYY') : '---'}</p></Col>
                                <Col span={6}><p>{`₹ ${currencyFormat(details?.subscriptionOrder?.plan ? details?.subscriptionOrder?.plan?.planAmount : 0)}`}</p></Col>
                                <Col span={6}><p style={{ paddingLeft: 15 }}>{`₹ ${currencyFormat(details?.subscriptionOrder?.plan ? details?.subscriptionOrder?.plan?.planAmount : 0)}`}</p></Col>
                                <Col span={6}><p className={classes.textAlignRight}>{`₹ ${currencyFormat(0)}`}</p></Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className={clsx(classes.receiptSecondSection, classes.bill, classes.receiptThirdSection, classes.yellowBorderTop)}>
                        <Col span={24}>
                            <p className={clsx(classes.receiptSecondSectionTitle, classes.bold)}>Particulars</p>
                            <Row className={classes.margin20t}>
                                <Col span={6}><h6>Service Period</h6></Col>
                                <Col span={6}><h6>Description</h6></Col>
                                <Col span={5}><h6 style={{ paddingLeft: 15 }}>HSN Code</h6></Col>
                                <Col span={3}><h6>GST Rate (%)</h6></Col>
                                <Col span={4}><h6 className={classes.textAlignRight}>Amount</h6></Col>
                            </Row>

                        </Col>
                    </Row>
                    <Row className={clsx(classes.receiptThirdSectionRow, classes.bill, classes.receiptThirdSection, classes.yellowBorderTop)}>
                        <Col span={6}>
                            <p>1 {
                                details?.subscriptionOrder?.plan?.frequency === 'YEARLY' ? 'Year' : details?.subscriptionOrder?.plan?.frequency === 'MONTHLY' ? 'Month' : details?.subscriptionOrder?.plan?.frequency === 'WEEKLY' ? 'Week' : ''
                            }
                            </p>
                        </Col>
                        <Col span={6}><p>{details?.subscriptionOrder?.plan?.description || '---'}</p>
                        </Col>
                        <Col span={5}><p style={{ paddingLeft: 15 }}>997331</p></Col>
                        <Col span={3}><p>18</p></Col>
                        <Col span={4}><p className={classes.textAlignRight}>{calculateTaxTotal()?.amount ? `₹ ${currencyFormat(calculateTaxTotal()?.amount)}` : '---'}</p></Col>
                    </Row>
                    <Row className={clsx(classes.bill, classes.yellowBorderTop)}>
                        <Col span={12}></Col>
                        <Col span={12} className={classes.yellowBorderLeft}>
                            <Row className={classes.receiptLastSectionRow}>
                                <Col span={9}><h6>SGST (%)</h6></Col>
                                <Col span={8}><p style={{ marginLeft: 15 }}>{calculateTaxTotal()?.sgst}</p></Col>
                                <Col className={classes.textAlignRight} span={7}><p>{`₹ ${currencyFormat(calculateTaxTotal()?.sgstAmount ? calculateTaxTotal()?.sgstAmount : 0)}`}</p></Col>
                            </Row>
                            <Row className={clsx(classes.receiptLastSectionRow, classes.yellowBorderTop)}>
                                <Col span={9}><h6>CGST (%)</h6></Col>
                                <Col span={8}><p style={{ marginLeft: 15 }}>{calculateTaxTotal()?.cgst}</p></Col>
                                <Col className={classes.textAlignRight} span={7}><p>{`₹ ${currencyFormat(calculateTaxTotal()?.cgstAmount ? calculateTaxTotal()?.cgstAmount : 0)}`}</p></Col>
                            </Row>
                            <Row className={clsx(classes.receiptLastSectionRow, classes.yellowBorderTop)}>
                                <Col span={9}><h6>IGST (%)</h6></Col>
                                <Col span={8}><p style={{ marginLeft: 15 }}>{calculateTaxTotal()?.igst}</p></Col>
                                <Col className={classes.textAlignRight} span={7}><p>{`₹ ${currencyFormat(calculateTaxTotal()?.igstAmount ? calculateTaxTotal()?.igstAmount : 0)}`}</p></Col>
                            </Row>
                            <Row className={clsx(classes.yellowBorderTop, classes.yellowBorderBottom)}>
                                <Col span={9} className={classes.receiptLastSectionRow}><h6>Grand Total</h6></Col>
                                <Col span={8}><p style={{ height: "100%", marginLeft: 20 }} className={classes.yellowBorderLeft}></p></Col>
                                <Col className={clsx(classes.receiptLastSectionRow, classes.textAlignRight)} span={7}><p>{details?.subscriptionOrder?.plan?.planAmount ? `₹ ${currencyFormat(details?.subscriptionOrder?.plan?.planAmount)}` : '---'}</p></Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div >
        </Modal >
    )
})

export default PaymentReceipt